import React from "react";
import { PlanClearingPartnerContainer } from "../../../containers";

const ClearingPartner = (props) => {
  return <PlanClearingPartnerContainer {...props} />;
};
export default ClearingPartner;
